<template>
<div>
  <div justify="center" v-if="Loaded">
<!-- <p>IDDDIDID: {{nurseId}}</p>
 {{getActivity}} -->
     <v-card class=" mt-4 mx-auto" max-width="1000" min-width="300">

  <v-toolbar class="pencil"   color="orange ligthen-1" dark>
          <v-toolbar-title>{{Hide?"Hej":"Tack"}} {{getActivity.name}}!
           
           </v-toolbar-title>

         
          <v-spacer></v-spacer>

        </v-toolbar>

  <v-expand-transition>
        <div v-if="Hide">
 <p v-if="school!=null"> Välkommen till oss på {{school.name}}. Vi tycker det är jättekul att du du börjar hos oss. Här får du en möjlighet att dela med dig av dig om det är något du tycker vi, personalen på skolan borde veta om dig. </p>
      
       <p class="title font-weight-bold">Detta kan vara bra att veta om mig:</p>
       <v-textarea
          solo
          v-model="getActivity.infoStudent"
          name="input-7-4"
          label="Information som du vill dela med dig av."
        ></v-textarea>  
            <v-btn dark color="blue ligthen-1" @click="updatePlan(getActivity);
showSuccessSnackbar('Informationen är inskickad. Återigen, välkommen till oss på '+school.name+'.');Hide=false;">
              Skicka in
            </v-btn> 
  <!-- <p v-show="false">{{Inlogged}}</p>

-->
        </div>
  </v-expand-transition>
</v-card> 
  </div>
  <div v-else class="loader text-xs-center">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
  },
 props: {
    nurseId: String
  },
  data: () => ({
      loaded:false,
      send:false,
      Hide: true,

  }),
  computed: {
   
    
    ...mapGetters('schools', ['school']),
    ...mapGetters("ehtmembers", ["getActivity"]),
    Loaded(){
      if (this.getActivity!= null) {
        this.loaded=true
        if (this.loaded==false) {
        this.initschool(this.getActivity.schoolId)
        }
        return true;
      }
      return false;
    },
  },
  methods: {

    ...mapActions('schools', ['initschool']),
      ...mapActions('ehtmembers', ['GetStartEnd']),

    ...mapActions(['showSuccessSnackbar']),
    ...mapActions("ehtmembers", ["updatePlan"]),

  },
  created () {
   
this.GetStartEnd(this.nurseId);
   
  },
}
</script>
<style>
.loader{
  margin-top: 20vh;
}



</style>
